const env = 'production';

const config = {
    development: {
        API_BASE_URL: 'http://127.0.0.1:8080'
    },
    production: {
        API_BASE_URL: 'http://www.halfpanda.cn'
    }
};

export const API_BASE_URL = config[env].API_BASE_URL;